import { withContextFactory } from "../contexts.utils";
import { PortalRootElementContext, TPortalRootElementContext } from "./PortalRootElementProvider";

export interface WithPortalRootElement {
    portalRootElementRef: TPortalRootElementContext;
}

export const withPortalRootElement = withContextFactory<WithPortalRootElement>(PortalRootElementContext, "portalRootElementRef");
